import styled from 'styled-components';
import { ListItem as ListItemCompoment } from 'src/components/list-item';
import { StoreLogo as StoreLogoComponent } from 'src/components/store-logo';
import { IconOutgoingLink } from '@prisjakt/ui/icon/outgoing-link';

export const StyledListItem = styled(ListItemCompoment)({
  '&&': {
    img: {
      marginRight: '10px',
    },
  },
});
export const StoreLogo = styled(StoreLogoComponent)`
  height: 24px;
  img {
    height: 16px;
    width: auto;
  }
`;

export const OutlinkCallToAction = styled.span`
  color: ${p => p.theme.colors.maybeBlue700};

  .pj-ui-product-list-item--grid:hover &,
  .pj-ui-product-row:hover & {
    color: ${p => p.theme.colors.maybeBlue500};
  }
`;

export const OutlinkIcon = styled(IconOutgoingLink)`
  margin-left: 5px;
  vertical-align: -2px;
  path {
    fill: currentColor;
  }
`;
